module.exports = __webpack_public_path__ + "static/media/ss.f1ba20fa.svg";